<!-- Rebate Request - Measurement Committee - View Valid Granted Rebate -->
<div *ngIf="!isRequestSucceeded">
    <ng-container *ngIf="!isReviewRebateComponent">
        <!-- Form Title [Primary] -->
        <h2 *ngIf="!isDefineRebateAdmin" class="sectionTitle">Measurement Committee - View Valid Granted Rebate</h2>
        <!-- Rebate Request - Display Mode -->
        <app-rebate-request *ngIf="!isDefineRebateAdmin" #rebateRequest (rebateRequestLoadedFlag)="onRebateRequestLoadedFlag($event)"></app-rebate-request>
        <!-- Form Title [Secondary] -->
        <div *ngIf="isDefineRebateAdmin" class="form-container">
            <h4 class="section-title">Measurement Committee - View Valid Granted Rebate</h4>
        </div>
        <div *ngIf="getRelatedRequestsObjects.length > 0" class="read-only-content">
            <!-- Related Requests -->
            <div class="form-container">
                <h4 class="section-title">Related Requests</h4>
            </div>
            <!-- Long Haul Related Requests Grid -->
            <div class="table-responsive">
                <table class="table table-bordered table-striped table-services">
                    <thead>
                        <tr>
                            <th><span>Rebate File Number</span></th>
                            <th><span>Request Number</span></th>
                            <th><span>Service</span></th>
                            <th><span>Request Status</span></th>
                            <th><span>Decision feedback Date</span></th>
                            <th><span>Direction</span></th>
                            <!--<th><span>Last Transit Date</span></th>-->
                            <th><span></span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let relatedRequest of getRelatedRequestsObjects; let i = index;">


                            <td>{{relatedRequest.RebateFileNumber}}</td>
                            <td>{{relatedRequest.RequestNumber}}</td>
                            <td>{{relatedRequest.serviceName}}</td>
                            <td>{{relatedRequest.Status}}</td>
                            <td>{{relatedRequest.DecisionDate}}</td>
                            <td>{{relatedRequest.SailDirection}}</td>
                           <!-- <td>{{relatedRequest.LastTransitDateString}}</td>-->
                            <td><a class="btn" (click)="relatedRequestDetails(i)">Details</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div [class.read-only-content]="formMode == 3 || formMode == 4">
            <!-- Form -->
            <form name="measurementCommitteeDecisionForm" [formGroup]="measurementCommitteeDecisionForm">
                <div class="form-container" #measurementCommitteeDecision>
                    <!-- Measurement Committee Decision Section -->
                    <div class="form-section">
                        <h4 class="section-title">Committee Decision</h4>
                        <div class="form-group">
                            <div class="custom-Radio">
                                <input type="radio" formControlName="LongHaulRequestMeasurementCommitteeDecisionId" id="rbtnLongHaulRequestMeasurementCommitteeDecisionIdAccept" value="1" (change)="onDecisionChange()" />
                                <label for="rbtnLongHaulRequestMeasurementCommitteeDecisionIdAccept">Accept</label>
                            </div>
                            <div class="custom-Radio">
                                <input type="radio" formControlName="LongHaulRequestMeasurementCommitteeDecisionId" id="rbtnLongHaulRequestMeasurementCommitteeDecisionIdRequireModification" value="2" (change)="onDecisionChange()" />
                                <label for="rbtnLongHaulRequestMeasurementCommitteeDecisionIdRequireModification">Require Modification</label>
                            </div>
                            <div class="custom-Radio">
                                <input type="radio" formControlName="LongHaulRequestMeasurementCommitteeDecisionId" id="rbtnLongHaulRequestMeasurementCommitteeDecisionIdReject" value="3" (change)="onDecisionChange()" />
                                <label for="rbtnLongHaulRequestMeasurementCommitteeDecisionIdReject">Reject</label>
                            </div>
                        </div>
                    </div>
                    <!-- Accept Section -->
                    <div *ngIf="isAccept" class="form-section" formGroupName="LongHaulRequestMeasurementCommitteeAccept">
                        <h4 class="section-title">Accept</h4>
                        <!-- SCID -->
                        <div class="form-group">
                            <label for="txtSCID">Vessel Number (SCID)</label>
                            <input type="text" formControlName="SCID" name="SCID" id="txtSCID" class="form-control" />
                            <div *ngIf="measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['SCID']?.invalid" class="red">
                                <span *ngIf="measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['SCID']?.errors?.pattern">This Field allows digits only</span>

                            </div>
                        </div>
                        <div class="form-group">
                            <label for="ddlVesselTypeId">Vessel Type</label>
                            <span class="red"> *</span>
                            <select formControlName="VesselTypeId" class="form-control" id="ddlVesselTypeId" name="VesselType">
                                <option value="" selected>Choose</option>
                                <option *ngFor="let vesselType of vesselTypes" [value]="vesselType?.Id" >
                                    {{vesselType?.NameEN}}
                                </option>
                            </select>
                            <div *ngIf=" isFormSubmitted && measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['VesselTypeId']?.invalid" class="red">
                            <div  *ngIf="measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['VesselTypeId']?.errors?.required">
                                {{'FRONT_USER.This_Field_Is_Required' | translate}}
                              </div>
                        </div>
                        </div>
                        <!-- Last Transit Date -->
                        <div class="form-group">
                            <label for="dpLastTransitDate">Last Transit Date</label>
                            <input #lastTransitDateDatepicker="bsDatepicker" bsDatepicker formControlName="LastTransitDate" [minDate]='null' [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', minMode: hour, maxDate: yearBuiltMaxDate}" autocomplete="off" id="dpLastTransitDate" class="form-control" name="LastTransitDate">
                        </div>
                        <!-- Rebate Last Transit -->
                        <div class="form-group" *ngIf="false" >
                            <label>Rebate on Last Transit</label>
                            <div class="form-custom-inputs">
                                <div>
                                    <div class="custom-Radio">
                                        <input type="radio" formControlName="RebateOnlastTransit" id="rbtnRebateOnlastTransitYes" name="RebateOnlastTransit" value="true" (change)="onRebateOnlastTransitChange()" />
                                        <label for="rbtnRebateOnlastTransitYes">Yes</label>
                                    </div>
                                    <div class="custom-Radio">
                                        <input type="radio" formControlName="RebateOnlastTransit" id="rbtnRebateOnlastTransitNo" name="RebateOnlastTransit" value="false" (change)="onRebateOnlastTransitChange()" />
                                        <label for="rbtnRebateOnlastTransitNo">No</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="isRebateOnlastTransit">
                            <!-- Rebate Value -->
                            <div class="form-group">
                                <label for="txtRebateValue">Rebate Value</label>
                                <input type="text" formControlName="RebateValue" name="RebateValue" id="txtRebateValue" class="form-control" />
                            </div>
                            <div class="form-group" *ngIf="formMode == 3 || formMode == 4">
                                <label for="txtPortOfOrigin">Old Origin</label>
                                <input type="text" formControlName="PortOfOrigin" name="PortOfOrigin" id="txtPortOfOrigin" class="form-control" />
                            </div>
                            <div class="form-group" *ngIf="formMode != 3 || formMode != 4">
                                <label for="txtPortOfOrigin">Origin</label>

                                <select formControlName="PortOfOrigin" class="form-control"
                                id="txtPortOfOrigin" name="PortOfOrigin">
                                <option value="" selected>Choose</option>
                                <option *ngFor="let country of countries" [value]="country?.NameEN">
                                    {{country?.NameEN}}
                                </option>
                                </select>
                            </div>

                            <div class="form-group" *ngIf="formMode == 3 || formMode == 4">
                                <label for="txtPortOfDestination">Old Destination</label>
                                <input type="text" formControlName="PortOfDestination" name="PortOfDestination" id="txtPortOfDestination" class="form-control" />
                            </div>
                            <div class="form-group" *ngIf="formMode != 3 || formMode != 4">
                                <label for="txtPortOfDestination">Destination</label>
                                <select formControlName="PortOfDestination" class="form-control"
                                id="txtPortOfDestination" name="PortOfDestination">
                                <option value="" selected>Choose</option>
                                <option *ngFor="let country of countries" [value]="country?.NameEN">
                                    {{country?.NameEN}}
                                </option>
                                </select>
                            </div>
                        </ng-container>
                        <!-- SCNT -->
                        <div class="form-group">
                            <label for="txtSCNT">Net Tonnage (SCNT)</label>
                            <span class="red"> *</span>
                            <input type="text" formControlName="SCNT" name="SCNT" id="txtSCNT" class="form-control" />
                            <div *ngIf="measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['SCNT']?.errors?.SCNTInvalid" style="color:orange;font-size:14px;">Your value cannot be greater than given value</div>
                                <div *ngIf=" isFormSubmitted && measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['SCNT']?.invalid" class="red">
                                <span *ngIf="measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['SCNT']?.errors?.pattern">Net Tonnage (SCNT) must be (1 to 6) digits and allows (1 to 2) Decimals</span>
                                <div  *ngIf="measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['SCNT']?.errors?.required">
                                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                  </div>
                            </div>
                        </div>
                        <!-- DWT -->
                        <div class="form-group">
                            <label for="txtDW">DWT</label>
                            <span class="red"> *</span>
                            <input type="text" formControlName="DW" name="DW" id="txtDW" maxlength="6" class="form-control" />
                            <div *ngIf="isFormSubmitted && measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['DW']?.invalid" class="red">
                                <span *ngIf="measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['DW']?.errors?.pattern">DWT allow digits only</span>
                                <span *ngIf="measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['DW']?.errors?.maxlength">This Field can be at most 50 characters</span>
                                <div  *ngIf="measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['DW']?.errors?.required">
                                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                  </div>
                            </div>
                        </div>
                        <!-- Direction -->
                        <div class="form-group">
                            <label for="ddlDirectionId">Direction</label>
                            <span class="red"> *</span>
                            <select formControlName="DirectionId" class="form-control" id="ddlDirectionId" name="Direction">
                                <option value="" selected>Choose</option>
                                <option *ngFor="let sailDirection of sailDirections" [value]="sailDirection?.Id" >
                                    {{sailDirection?.Direction}}
                                </option>
                            </select>

                            <div *ngIf="isFormSubmitted && measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['DirectionId']?.invalid" class="red">
                                <div  *ngIf="measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['DirectionId']?.errors?.required">
                                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                  </div>
                            </div>

                        </div>
                        <!-- Number Of Tugs
                        <div class="form-group">
                            <label for="txtNumberOfTugs">Number of Tugs</label>

                            <label class="form-control" disabled="disabled" name="NumberOfTugs" id="lblNumberOfTugs">{{numberOfTugs}}</label>
                        </div>-->
                       <!-- <ng-container *ngIf="formMode == 1 || formMode == 2">

                            <div class="form-group" *ngFor="let tugLongHaulRequestMeasurementCommitteeDecisionAccept of tugsLongHaulRequestMeasurementCommitteeDecisionAccept; let t = index;">
                                <label for="NumberOfTugs">Number of {{tugLongHaulRequestMeasurementCommitteeDecisionAccept.TugNameEN}}</label>
                                <div class="input-group">
                                    <input type="number" min="0" class="form-control" id="txtNumberOfTugs" name="NumberOfTugs" [(ngModel)]="tugLongHaulRequestMeasurementCommitteeDecisionAccept.NumberOfTugs" formControlName="TugsLongHaulRequestMeasurementCommitteeDecisionAccept" (change)="tugValueChange($event)" />
                                    <span class="input-group-addon">{{tugLongHaulRequestMeasurementCommitteeDecisionAccept.TugNameEN}}</span>
                                </div>
                            </div>
                        </ng-container> -->
                       <!-- <ng-container *ngIf="formMode == 3">

                            <div class="form-group" *ngFor="let tugLongHaulRequestMeasurementCommitteeDecisionAccept of tugsLongHaulRequestMeasurementCommitteeDecisionAccept; let t = index;">
                                <label for="NumberOfTugs">Number of {{tugLongHaulRequestMeasurementCommitteeDecisionAccept.TugNameEN}}</label>
                                <div class="input-group">
                                    <label class="form-control" disabled="disabled" name="NumberOfTugs" id="lblNumberOfTugs">{{tugLongHaulRequestMeasurementCommitteeDecisionAccept.NumberOfTugs}}</label>
                                    <span class="input-group-addon">{{tugLongHaulRequestMeasurementCommitteeDecisionAccept.TugNameEN}}</span>
                                </div>
                            </div>
                        </ng-container>-->
                        <!-- Rate -->
                        <div class="form-group">
                            <label for="ddlRateId">Rate</label>
                            <span class="red"> *</span>
                            <select formControlName="RateId" class="form-control" id="ddlRateId" name="Rate">
                                <option value="" selected>Choose</option>
                                <option *ngFor="let rate of rates" [value]="rate?.Id" >
                                    {{rate?.NameEN}}
                                </option>
                            </select>
                            <div *ngIf="isFormSubmitted && measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['RateId']?.invalid" class="red">
                            <div  *ngIf="measurementCommitteeDecisionForm?.controls['LongHaulRequestMeasurementCommitteeAccept']?.controls['RateId']?.errors?.required">
                                {{'FRONT_USER.This_Field_Is_Required' | translate}}
                              </div>
                        </div>
                        </div>
                        <!-- Extra Cost -->
                        <div class="form-group">
                            <label for="txtExtraCost">Extra Cost</label>
                            <input type="text" formControlName="ExtraCost" name="ExtraCost" id="txtExtraCost" class="form-control" />
                        </div>
                        <!-- Notes & Comments -->
                        <div class="form-group">
                            <label for="txtNotesAndComments">Notes and Comments</label>
                            <textarea type="text" formControlName="NotesAndComments" name="NotesAndComments" id="txtNotesAndComments" class="form-control"></textarea>
                        </div>
                    </div>
                    <!-- Require Modification Section -->
                    <div *ngIf="isRequireModification" class="form-section">
                        <h4 class="section-title">Require Modification</h4>
                        <!-- Comment -->
                        <div class="form-group">
                            <label for="txtRequireModificationNotesAndComments">Comment</label>
                            <span class="red"> *</span>
                            <textarea formControlName="RequireModificationNotesAndComments" id="txtRequireModificationNotesAndComments" name="RequireModificationNotesAndComments" class="form-control"></textarea>
                            <div *ngIf="isFormSubmitted && measurementCommitteeDecisionForm?.controls['RequireModificationNotesAndComments']?.invalid" class="red">
                                <span *ngIf="measurementCommitteeDecisionForm?.controls['RequireModificationNotesAndComments']?.errors?.required">This Field is Required</span>
                            </div>
                        </div>
                    </div>
                    <!-- Reject Section -->
                    <div *ngIf="isReject" class="form-section">
                        <h4 class="section-title">Reject</h4>
                        <!-- Rejection Reason -->
                        <div class="form-group">
                            <label for="txtRejectionReason">Rejection Reason</label>
                            <span *ngIf="formMode == 1 || formMode == 2" class="red"> *</span>
                            <textarea formControlName="RejectionReason" id="txtRejectionReason" name="RejectionReason" class="form-control"></textarea>
                            <div *ngIf="isFormSubmitted && measurementCommitteeDecisionForm?.controls['RejectionReason']?.invalid" class="red">
                                <span *ngIf="measurementCommitteeDecisionForm?.controls['RejectionReason']?.errors?.required">This Field is Required</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="isSubmitEnabled" class="form-group">
                    <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="submit()">Submit</button>
                    <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button>
                </div>
            </form>
        </div>
    </ng-container>
</div>
<!-- Confirmation -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 1" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                </g>
            </g>
        </svg>
        <p>You have submitted Rebate Request Decision Successfully</p>
        <p *ngIf="submitMeasurementCommitteeDecisionResponseObject.Data != null">Rebate File Number [{{submitMeasurementCommitteeDecisionResponseObject.Data}}]</p>
        <p>Go Back to <a routerLink="/myTasks">My Tasks</a></p>
    </div>
</div>
<!-- Warning -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 2" class="alert alert-warning" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                </g>
            </g>
        </svg>
        <p>This task was submitted before</p>
        <p>Go Back to <a routerLink="/myTasks">My Tasks</a></p>
    </div>
</div>
<!-- Error -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 3" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>Something went wrong, Please contact System Administrator</p>
        <hr>
        <p>Go Back to <a routerLink="/workspace">Workspace</a></p>
    </div>
</div>
